
import { Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import HomePage from './pages/HomePage'
import BatchScanPage from './pages/BatchScanPage'
import ReportsPage from './pages/ReportsPage'
import ReportDetailPage from './pages/ReportDetailPage'
import DashboardPage from './pages/DashboardPage'
import SettingsPage from './pages/SettingsPage'
import WcagValidatorPage from './pages/WcagValidatorPage'
import AdaCompliancePage from './pages/AdaCompliancePage'
import ProjectsPage from './pages/ProjectsPage'
import LoginPage from './pages/LoginPage'
import { BlogListSSG } from './pages/BlogListSSG'
import { BlogPostSSG } from './pages/BlogPostSSG'

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/wcag-validator" element={<WcagValidatorPage />} />
            <Route path="/ada-compliance-checker" element={<AdaCompliancePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/blog" element={<BlogListSSG />} />
            <Route path="/blog/:slug" element={<BlogPostSSG />} />
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Routes */}
            <Route path="/batch" element={
              <ProtectedRoute>
                <BatchScanPage />
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            } />
            <Route path="/reports/:reportId" element={
              <ProtectedRoute>
                <ReportDetailPage />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            } />
            
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </HelmetProvider>
  )
}

export default App
